/**
 * BucketBar — My Day bucket tab selector
 */
import React from 'react';
import { Badge } from '../ui/badge';
import { BUCKET_CONFIG } from './constants';

export function BucketBar({ activeBucket, summary, onSelect }) {
  return (
    <div className="px-6 pb-3 flex gap-1.5" data-testid="bucket-bar">
      {Object.entries(BUCKET_CONFIG).map(([key, cfg]) => {
        const count = summary[key] || 0;
        const isActive = activeBucket === key;
        const Icon = cfg.icon;
        return (
          <button
            key={key}
            onClick={() => onSelect(key)}
            className={`
              flex items-center gap-1.5 px-3.5 py-2 rounded-lg text-[13px] font-medium transition-all duration-150
              ${isActive
                ? 'bg-slate-800 text-white shadow-sm'
                : 'text-slate-600 hover:text-slate-800 hover:bg-slate-50'
              }
            `}
            data-testid={`bucket-tab-${key}`}
          >
            <Icon className="w-3.5 h-3.5" />
            <span>{cfg.label}</span>
            {count > 0 && (
              <span className={`text-[11px] font-semibold rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1
                ${isActive ? 'bg-white/20 text-white' : 'bg-slate-100 text-slate-500'}`}
                data-testid={`bucket-count-${key}`}>
                {count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}


/* ═══════════════════════════════════════
   WORK ITEM
   ═══════════════════════════════════════ */

